import { render, staticRenderFns } from "./vehicleservicehistory.html?vue&type=template&id=1240bdfd&scoped=true&external"
import script from "./vehicleservicehistory.vue?vue&type=script&lang=js"
export * from "./vehicleservicehistory.vue?vue&type=script&lang=js"
import style0 from "./vehicleservicehistory.vue?vue&type=style&index=0&id=1240bdfd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1240bdfd",
  null
  
)

export default component.exports